
import Injection = EECore.Injection;
import Model from "../models/documentCentre/favouritesModel";
import DocumentModel from "../models/documentCentre/favouriteDocumentModel";
import WidgetBoxModel from "../models/common/widgetBoxModel";
import DocumentService from "../../services/documentCentre/documentService";
import DocumentBehavior from "../../behaviors/documentCentre/favouriteDocumentBehavior";
import DocumentListBehavior from "../../behaviors/documentCentre/favouriteDocumentListBehavior";
import { WidgetResources } from "../../resources/widget";

@Injection.injectableClass("DocumentCentreFavourites")
export default class Favourites implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("DocumentCentreFavourites", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("DocumentCentreFavourites", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("DocumentCentreFavourites", "DocumentCentreDocumentService")
  private documentService: DocumentService;

  @Injection.injectableProperty("DocumentCentreFavourites", "DocumentCentreFavouriteDocumentBehavior")
  private documentBehavior: DocumentBehavior;

  @Injection.injectableProperty("DocumentCentreFavourites", "DocumentCentreFavouriteDocumentListBehavior")
  private documentListBehavior: DocumentListBehavior;

  constructor(templateFactory: EECore.UI.TemplateFactory, resources: WidgetResources, documentService: DocumentService, documentBehavior: DocumentBehavior, documentListBehavior: DocumentListBehavior) {
    this.templateFactory = templateFactory;
    this.resources = resources;
    this.documentService = documentService;
    this.documentBehavior = documentBehavior;
    this.documentListBehavior = documentListBehavior;
  }

  load(container: Element): EECore.Promise<Element, string> {
    const withBox = container.getAttribute("ee-with-box") === "true";
    const title = container.getAttribute("ee-title");

    return new EECore.Promise<Element, string>((resolve) => {
      const request = this.documentService.getFavouriteDocuments();
      request.then((documents: DocumentModel[]) => {
        const component = this.renderTemplate(documents.length, withBox, title);
        this.documentListBehavior.apply(component);
        const documentContainer = component.querySelector(".documents");
        this.loadDocuments(documentContainer, documents);
        resolve(component);
      }).catch((message: string) => {
        const component = this.renderTemplate(0, withBox, title);
        const errorContainer = component.querySelector("[data-content=message]");
        errorContainer.innerHTML = message;
        resolve(component);
      });
    });
  }

  private renderTemplate(documentCount: number, withBox: boolean, title: string): Element {
    const model: Model = {
      showAllVisibility: documentCount <= 10 ? "hidden" : "visible",
      showAllLabel: this.resources.documentCentre.favourites.showAllLabel
    };

    let template = this.templateFactory.getTemplate("DocumentCentreFavourites", model);
    if (withBox) {
      const boxModel: WidgetBoxModel = {
        title: title || this.resources.documentCentre.favourites.titleLabel
      };

      const box = this.templateFactory.getTemplate("WidgetBox", boxModel);
      box.querySelector(".content").appendChild(template);
      template = box;
    }

    return template;
  }

  private loadDocuments(documentContainer: Element, documents: DocumentModel[]) {
    for (let i = 0; i < documents.length; i++) {
      documents[i].visibility = i < 10 ? "visible" : "hidden";
      documents[i].moveDownTooltip = this.resources.documentCentre.favourites.moveDownTooltip;
      documents[i].moveUpTooltip = this.resources.documentCentre.favourites.moveUpTooltip;
      documents[i].removeTooltip = this.resources.documentCentre.favourites.removeTooltip;
      const document = this.templateFactory.getTemplate("DocumentCentreFavourite", documents[i]);
      this.documentBehavior.apply(document);
      documentContainer.appendChild(document);
    }
  }
}